import React, { useEffect, useState } from 'react'
import { Typography, Textarea } from '@mui/joy'
import { SxProps } from '@mui/joy/styles/types'
import { useUpdateStoreMutation } from '../services/branding'

type EditableTypographyProps = {
  initialText: string
  font: string
  backgroundColor: string | undefined
  textColor: string
  sx: SxProps
  props: object
}

function EditableTypography(props: EditableTypographyProps) {
  const [isEditing, setIsEditing] = useState(false)
  const [text, setText] = useState(props.initialText)

  const handleDoubleClick = () => setIsEditing(true)

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) =>
    setText(event.target.value)

  const handleBlur = () => {
    setIsEditing(false)
    updateStore({ text })
  }

  useEffect(() => {
    setText(props.initialText)
  }, [props.initialText])

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      setIsEditing(false)
      updateStore({ text })
    }
  }

  const [updateStore] = useUpdateStoreMutation({
    fixedCacheKey: 'shared-delete-reward',
  })

  return (
    <>
      {isEditing ? (
        <Textarea
          autoFocus
          value={text}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          sx={{
            textAlign: 'center',
            lineHeight: 'normal',
            backgroundColor: props.backgroundColor,
            color: props.textColor,
            fontWeight: 'md',
            fontFamily: props.font,
            fontSize: 16,
            ...props.sx,
          }}
        />
      ) : (
        <Typography
          onDoubleClick={handleDoubleClick}
          textColor={props.textColor}
          sx={{ cursor: 'pointer', fontSize: 20, ...props.sx }}
          fontFamily={props.font}
          {...props.props}
        >
          {props.initialText}
        </Typography>
      )}
    </>
  )
}

export default EditableTypography
